// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// GetAreaEducationAgencyDetailsHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import AreaEducationAgencyDTO from '../models/AreaEducationAgencyDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    id: string | null;
    academicYear: number | null | null;
    areaEducationAgencyId: number | null | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            id: '00000000-0000-0000-0000-000000000000',
            academicYear: null,
            areaEducationAgencyId: null,
        },
        initValues);
    },
    id: 'id',
    academicYear: 'academicYear',
    areaEducationAgencyId: 'areaEducationAgencyId',
}

interface Result extends ResultDTO {
    areaEducationAgency: AreaEducationAgencyDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            areaEducationAgency: null,
        },
        initValues);
    },
    areaEducationAgency: 'areaEducationAgency',
}

export { Request, Result };